import { render, staticRenderFns } from "./JournalEntryTable.vue?vue&type=template&id=32d89f8c&"
import script from "./JournalEntryTable.vue?vue&type=script&lang=js&"
export * from "./JournalEntryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports